import { useSelector } from 'react-redux';

import { FILE_PATH_IN_REPORTS } from '../../../../../../../../shared/featureFlags/flagNames';
import { DependencyInfoOptions } from '../../../../../../../../shared/reports';
import { isFeatureEnabled } from '../../../../../../../helpers/features';
import * as reportGeneration from '../../../../../../../redux/reportGeneration';
import FilterCardCheckboxes from '../../../../../../generic/Filter/FilterCardCheckboxes';
import type { SelectOption, SetState } from '../../../../../../../types';

type Props = {
  values: SelectOption[];
  setValues: SetState<SelectOption[]>;
};

const DependencyMetadataCheckboxGroup = ({ values, setValues }: Props) => {
  const isFilePathInReports = isFeatureEnabled(FILE_PATH_IN_REPORTS);
  const projectType = useSelector(reportGeneration.selectors.getProjectType);
  const options = Object.entries(DependencyInfoOptions)
    .filter(([key]) => {
      if (key === 'FilePath') {
        return isFilePathInReports;
      }
      if (key === 'Project') {
        return projectType === 'releaseGroup';
      }

      return true;
    })
    .map(([key, value]) => ({ label: value, value: key }));
  return (
    <div className="width-full" data-test-id="sbom-filters-dependency-metadata">
      <FilterCardCheckboxes label="Dependency Metadata" options={options} values={values} onChange={setValues} />
    </div>
  );
};

export default DependencyMetadataCheckboxGroup;
